import logo from "./assets/logo.png";
import img1 from "./assets/image1.png";
import img2 from "./assets/image2.png";
import img3 from "./assets/image3.png";
import img4 from "./assets/image4.png";
import img5 from "./assets/image5.png";
import img6 from "./assets/image6.png";
import img7 from "./assets/image7.png";
import img8 from "./assets/image8.png";
import img9 from "./assets/image9.png";
import img10 from "./assets/image10.png";
import img12 from "./assets/image12.png"
import { Table } from "react-bootstrap";
function App() {
  return (
    <div class="container">
      <div class="logo">
        <img src={logo} alt="logo" />
        <h1>Helium warz Guide</h1>
      </div>
      <h3 class="version">Edition of 09.08.2024</h3>
      <h2 class="title my-3">Who we are</h2>
      <p class="content">
        Helium War is an adventure-tapping game where players explore various adventure zones, complete daily challenges to earn rewards, invite friends to join, and dive into challenging gameplay.
      </p>
      <h2 className="title mt-4">How to play </h2>
      <div className="gap-3 mt-2 d-md-flex align-items-start img_box">
        <p className="content">
          Tap on the crystal, and all your earnings will be displayed on the main screen.
        </p>
        <div>
          <img src={img5} alt="guide-image" />
          <p className="content text-center"><b>Upgrade, Coins, and earns</b>
          </p>
        </div>
      </div>
      <p className="content">
        Users reach ultimate levels by collecting a specific amount of coins, which results in level-ups and rewards that increase their energy limits.
      </p>
      <Table responsive>
        <thead>
          <tr>
            <th>LVL</th>
            <th>Lvl Name</th>
            <th>Current Balance
            </th>
            <th>Energy limit
            </th>
          </tr>
        </thead>
        <tbody>
          {
            [
              { id: 1, name: "Aether", start: 0, end: 2000 },
              { id: 2, name: "Valor", start: 100001, end: 2500 },
              { id: 3, name: "Horizon", start: 1100001, end: 3000 },
              { id: 4, name: "Astral", start: 6000001, end: 3500 },
              { id: 5, name: "Sentinel", start: 16000001, end: 4000 },
              { id: 6, name: "Aetheria vs Valeria", start: 56000001, end: 4500 },
              { id: 7, name: "Helium Wars", start: 136000001, end: 5000 }
            ].map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.start}</td>
                  <td>{item.end}</td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <div className="gap-3 d-md-flex align-items-start justify-content-between mt-4">
        <img src={img9} alt="help-guide-image" />
        <img src={img4} alt="help-guide-image" />
      </div>
      <p className="content">Earning coins is simple: tap on the screen, and each tap gives you 1 coin.</p>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Energy Booster</h3>
          <ul>
            <li>You have 6 boosters available per day.
            </li>
            <li>When you exhaust your tapping power and want to continue immediately, you can use Full Energy to bypass the auto-refilling time.
            </li>
            <li>After using boosters to update your energy, you must wait 1 hour before using them again.
            </li>
          </ul>
          <p className="content">You can also get extra coins in the earn section </p>
        </div>
        <img src={img2} alt="help" />
      </div>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Earn more coin</h3>
          <p className="content">In this game, you'll need to complete activities to earn points:
          </p>
          <ul>
            <li>
              Join our Telegram channel - 500 points
            </li>
            <li>
              Follow us on different media platforms:
              <ul>
                <li>Follow our X account - 500 points</li>
              </ul>
            </li>
          </ul>
        </div>
        <img src={img1} alt="help" />
      </div>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Daily reward</h3>
          <p className="content">You will receive reward points as follows:</p>
          <ul>
            <li>Day 1: Earn 250 coins</li>
            <li>Day 2: Earn 500 coins</li>
            <li>Day 3: Earn 1K coins</li>
            <li>This will continue increasing until the 10th day, after which it will reset and start again. If you do not claim your daily reward the next day, the cycle will reset and start from the beginning.
            </li>
          </ul>
        </div>
        <img src={img8} alt="help" />
      </div>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Daily Challenges</h3>
          <p className="content">You will receive reward points as follows:</p>
          <ul>
            <li>Tap continuously on the crystal.</li>
            <li>A progress bar will show your tapping progress.</li>
            <li>If you stop tapping, the progress bar will decrease.</li>
            <li>You have 20 seconds to complete the challenge.</li>
          </ul>
        </div>
        <img src={img10} alt="help" />
      </div>
      <div className="mt-4 ">
        <h3>Passive Income</h3>
        <p className="content">In this game, you need to purchase resource buildings to initiate passive income. These buildings generate profit per hour, meaning you can upgrade them to continue earning even when you are not actively playing.
        </p>
        <p className="content">
          <b>Note: </b>The duration of passive income is limited to three hours following game logout. The mining then comes to an end, and you have to restart the game.
        </p>
      </div>
      <div className="gap-3 d-md-flex align-items-start justify-content-between mt-4">
        <img src={img12} alt="help-guide-image" />
        <img src={img7} alt="help-guide-image" />
      </div>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Invite Friends</h3>
          <ul>
            <li>In the "Friends" section, you can send an invitation link. When your friend clicks on it, their name will appear at the bottom of your friend's list.</li>
            <li>As a participant in our referral program, you will receive 500 coins.
            </li>
          </ul>
        </div>
        <img src={img6} alt="help" />
      </div>
      <div className="mt-4 gap-3 d-md-flex align-items-start justify-content-between">
        <div>
          <h3>Airdrop: <b>Coming soon</b></h3>
        </div>
        <img src={img3} alt="help" />
      </div>
    </div>
  );
}

export default App;
